import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "23.5",
  cy: "9.5",
  r: "5",
  stroke: "#F69100"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "M28 26.5s.468-1.505.5-2.5c.038-1.187-.5-3-.5-3l3 2 .727 4.36a1.962 1.962 0 1 0 3.867-.663l-.938-5.312a2 2 0 0 0-.921-1.356l-5.253-3.232a2 2 0 0 0-1.048-.297h-7.93c-.331 0-.657.082-.948.24L13.5 19.5c-.452.244-.813.944-.973 1.343-.072.179-.12.369-.181.552l-1.678 5.046c-.111.336-.202.691-.125 1.037a1.945 1.945 0 0 0 3.694.325c.195-.468.245-.99.432-1.46L16 23l3-2s-.537 1.813-.5 3c.033.995.5 2.5.5 2.5m9 0 .5 3m-.5-3h-9m9.5 3 3.06 1.913a2 2 0 0 1 .94 1.695V40a2 2 0 1 1-4 0v-5.5L26 33m2.5-3.5A2.5 2.5 0 0 0 26 32v1m0 0s-1 1-2.5 1-2.5-1-2.5-1m-2-6.5-.5 3m0 0-3.06 1.913a2 2 0 0 0-.94 1.695V40a2 2 0 1 0 4 0v-5.5L21 33m-2.5-3.5A2.5 2.5 0 0 1 21 32v1"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }